import { isEmpty } from 'validate.js';

import {
  LINE_ITEM_TYPES,
  PAYMENT_REQUEST_CATEGORIES
} from 'dpl/shared/constants/breeder_app';
import { capitalize } from 'dpl/shared/utils';

export function ensureCurrencyIsPresent(price) {
  if (price == null || Number.isNaN(price)) {
    return '';
  }

  return price.toString().startsWith('$') ? price : `$${price}`;
}

export function createLineItems(
  paymentFeeData,
  chargeAmountInDollars,
  chargeCategory,
  breederProfile
) {
  const base = [];
  const amountInDollars = parseFloat(chargeAmountInDollars);

  const platformFeeLongDescription =
    chargeCategory === PAYMENT_REQUEST_CATEGORIES.DOG_PAYMENT
      ? paymentFeeData.fee_long_description_deposit
      : paymentFeeData.fee_long_description;

  if (
    !isEmpty(breederProfile) &&
    chargeCategory === PAYMENT_REQUEST_CATEGORIES.DEPOSIT
  ) {
    base.push({
      description: 'Deposit',
      long_description: [
        breederProfile.deposit_refund_policy &&
          capitalize(breederProfile.deposit_refund_policy),
        paymentFeeData.subtotal_long_description
      ]
        .filter(Boolean)
        .join(', '),
      amount_in_dollars: ensureCurrencyIsPresent(amountInDollars.toFixed(2)),
      type: LINE_ITEM_TYPES.CHARGE,
      deposit_description: breederProfile.deposit_description
    });
  } else {
    base.push({
      long_description: paymentFeeData.subtotal_long_description,
      description: 'Subtotal',
      amount_in_dollars: ensureCurrencyIsPresent(amountInDollars.toFixed(2)),
      type: LINE_ITEM_TYPES.CHARGE
    });
  }

  base.push({
    long_description: platformFeeLongDescription,
    description: paymentFeeData.fee_description,
    amount_in_dollars: paymentFeeData.fee_in_dollars,
    type: LINE_ITEM_TYPES.FEE
  });

  base.push({
    description: paymentFeeData.processing_fee_description,
    tooltipDescription: paymentFeeData.processing_fee_tooltip_description,
    amount_in_dollars: paymentFeeData.processing_fee_in_dollars,
    type: LINE_ITEM_TYPES.PROCESSING_FEE,
    discountedPriceInDollars: paymentFeeData.processing_fee_discount_in_dollars
  });

  return base;
}

export function getPaymentAndSupportListItems(amount, dogPayment = false) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    `Your ${amountText}payment is fully protected under the Good Dog Guarantee`,
    `Our team will jump in to help if anything goes wrong`,
    dogPayment &&
      'Exclusive discounts on puppy essentials from Chewy, Rover, BarkBox and more',

    dogPayment &&
      'Lifetime access to our Puppy Training Program, including live coaching and a supportive community, valued at $235'
  ].filter(Boolean);
}

export function getBasicProtectionAndSupportListItems(
  amount,
  dogPayment = false
) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    !dogPayment &&
      `Your ${amountText}payment is not protected under our policies`,
    dogPayment && 'Our team will not be able to mediate any issues',
    !dogPayment &&
      'Our team will not be able to support you if an issue arises',
    dogPayment && 'Lose access to puppy training & coaching',
    'Designed specifically for trusted friends & family'
  ].filter(Boolean);
}
